import * as faceapi from "face-api.js";

export const useWebcam = {
  data() {
    return {
      webcamStream: null,
      constraints: {
        video: true,
        audio: false,
      },
    };
  },
  methods: {
    async enableWebcam() {
      await this.prepareModels();
      await navigator.mediaDevices
        .getUserMedia(this.constraints)
        .then((mediaStream) => {
          this.$refs.webcam.srcObject = mediaStream;
          this.$refs.webcam.onloadedmetadata = async () => {
            this.webcamStream = mediaStream;
            this.$refs.webcam.play();
            await this.recognize();
          };
        });
    },
    async prepareModels() {
      const modelsUrl = `${process.env.BACKEND_URL}/auth_models`;
      await faceapi.loadTinyFaceDetectorModel(modelsUrl);
      await faceapi.loadFaceRecognitionModel(modelsUrl);
      await faceapi.loadFaceLandmarkModel(modelsUrl);
      await faceapi.loadFaceExpressionModel(modelsUrl);
    },
    disableWebcam() {
      if (!this.webcamStream) {
        return;
      }
      this.webcamStream.getTracks().forEach((track) => {
        const { kind, readyState } = track;
        const webcamIsEnabled = readyState === "live" && kind === "video";
        if (webcamIsEnabled) {
          track.stop();
        }
      });
    },
    makeSnapshot() {
      const snapshotCanvas = document.querySelector("#snapshotCanvas");
      const context = snapshotCanvas.getContext("2d");
      context.drawImage(
        this.$refs.webcam,
        0,
        0,
        snapshotCanvas.width,
        snapshotCanvas.height
      );
      const readySnapshot = snapshotCanvas.toDataURL("image/jpg");
      return readySnapshot;
    },
  },
};



// WEBPACK FOOTER //
// ./src/authorization/mixins/useWebcam.js